import LioshutanApi from '@/api/lib/lioshutanApi';

export default LioshutanApi;
